var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19.0859,
    r: 16.625,
    fill: "url(#paint0_linear_3149_6282)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1913 24.1703L25.9298 19.4779H21.3099V16.4342C21.3099 15.1502 21.9541 13.8978 24.0233 13.8978H26.125V9.90299C26.125 9.90299 24.2185 9.58594 22.3966 9.58594C18.5901 9.58594 16.1045 11.8338 16.1045 15.9016V19.4779H11.875V24.1703H16.1045L16.1045 35.5144C16.9536 35.6444 17.8223 35.7109 18.7072 35.7109C19.5921 35.7109 20.4608 35.6444 21.3099 35.5144L21.3099 24.1703H25.1913Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3149_6282",
    x1: 19,
    y1: 2.46094,
    x2: 19,
    y2: 35.6123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18ACFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0163E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.f17e1aa4c04d2e4c51ae8b2f0004d814.svg";
export { ForwardRef as ReactComponent };